<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Banking"/>
    </div>
    <div class="text-left" v-if="details">
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>Currency Used</h5>
        </mdb-card-header>
        <mdb-card-body>
          <gp-select :dataObj="details" :possible-values="validCurrencies" :required="true" label="Currency"
                     propertyName="currencyCode"/>
          <mdb-input :maxlength="1" label="Currency Symbol" type="text" v-model="details.currencySymbol"/>

        </mdb-card-body>
      </mdb-card>
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h5>Accepting Credit Cards</h5>
        </mdb-card-header>
        <mdb-card-body>
          <div class="text-info" v-if="!details.stripePublicKey">
            <p>{{ settings.siteName }} uses <a href="https://stripe.com" target="_blank">Stripe</a> to process payments from your
              members.
              The financial agreement is between you and Stripe. {{ settings.siteName }} simply facilitates the
              payments and recording to your account using Stripe credentials your provide to {{ settings.siteName }}.
            </p>

            <p>To get started, create an account on <a href="https://stripe.com" target="_blank">Stripe</a>.</p>

            <p>In the "Developers" section of the site, look for "API Keys". You will need to provide {{ settings.siteName }}
              your publishable key and a secret key.</p>

            <p>Although you may use the default standard secret key in your account, <b>it is
              highly recommended</b> that you <i><b>create a restricted key</b></i>
              that only has "read and write" to the "charges" resource. This will
              limit the access {{settings.siteName}} has to your account only
              to allow us to make charges on your behalf.
            </p>
          </div>
          <mdb-input label="Publishable Key" type="text" v-model="details.stripePublicKey"/>
          <mdb-input label="Secret Key" type="text" v-model="details.stripeSecretKey"/>
          <mdb-btn @click="doSave" icon="save">Save
          </mdb-btn>
        </mdb-card-body>

      </mdb-card>
    </div>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mapState} from 'vuex'
import bannerSmall from '../group/BannerSmall'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbInput,} from 'mdbvue';
import gpSelect from "../common/GPSelect";

export default {
    name: "group-banking",
    display: "venue",
    order: 1,
    components: {
      mdbContainer,
      mdbBtn,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbIcon,
      mdbInput,
      bannerSmall,
      gpSelect
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup,
                         settings: state => state.settings
                       }),
    data() {
      return {
        details: null,
        validCurrencies: [],
      }
    },
    mounted() {
      document.title = "Banking"
      this.$store.dispatch("setExecuting", true)
      api.get("/group/banking/" + this.$route.params.id).then(
        (results) => {
          this.details = results.data;
          if (!this.currentGroup || this.currentGroup.id != this.details.groupId) {
            api.groupBasics(this.details.groupId, "public");
          }
          for (let i = 0; i < this.details.validCurrencies.length; i++) {
            let row = this.details.validCurrencies[i]
            this.validCurrencies.push({text: row.descr, value: row.code})
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    methods: {
      doSave: function () {
        this.$store.dispatch("setExecuting", true)

        api.post("/group/banking/" + this.currentGroup.vanityPath, this.details).then(
          (details) => {
            this.$notify.success({message: "Banking updated successfully.", timeOut: 3000})
          },
          (error) => {
            this.$notify.error({message: error.response.data})
          }
        ).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }
  };

</script>

